import { List, ListItem, ListItemText, Paper, Typography } from "@mui/material";
import ProjectPositionDTO from "../../dto/ProjectPositionDTO";
import { Box } from "@mui/material";
import OpsPanel from "../OpsPanel";
import { Token } from "../../theme";
import newFolder from "../../img/icons/new_folder.svg";
import OpsDateUtils from "../../utils/OpsDateUtils";

interface Props {
  projectPositions: ProjectPositionDTO[];
}

export const Positions = ({ projectPositions }: Props) => {
  return (
    <OpsPanel title="Project list / Positions" svg={newFolder}>
      <Box sx={{ maxHeight: "15.5em", overflow: "auto", display: "flex", flexDirection: "column", gap: 1 }}>
        {projectPositions.length ? (
          projectPositions.map((p, index) => (
            <Box
              key={index}
              sx={{
                border: `1px solid ${Token.borderDefault}`,
                borderLeft: `3px solid ${Token.brandAccent}`,
                borderRadius: `${Token.radiusCard}`,
                padding: "12px",
                backgroundColor: Token.surfaceRaised,
              }}
            >
              <Typography fontWeight={600} fontSize="13px" color={Token.textPrimary}>
                {p.positionName}
              </Typography>
              <Typography fontSize="11.5px" color={Token.textTertiary}>
                {p.projectName}
                {`· Assignation ` + p.assignationId}
                {p.shortStartDate && ` · since ${OpsDateUtils.ensureFormatDateUTC(p.shortStartDate)}`}
              </Typography>

              {p.dailyHours != null && (
                <Box sx={{ pt: 1 }}>
                  <Typography fontSize="10.5px" color={Token.textTertiary} sx={{ textTransform: "uppercase", letterSpacing: "0.04em" }}>
                    Weekly
                  </Typography>
                  <Typography fontSize="13px" color={Token.textPrimary} sx={{ fontFamily: "var(--font-mono)" }}>
                    {`${p.dailyHours * 5} h`}
                  </Typography>
                </Box>
              )}
            </Box>
          ))
        ) : (
          <Typography fontSize="12.5px" color={Token.textTertiary} sx={{ padding: "8px 12px" }}>
            No data
          </Typography>
        )}
      </Box>
    </OpsPanel>
  );
};
